import { render } from "./LegacyStyleCompatShell.vue?vue&type=template&id=6258711e&scoped=true"
import script from "./LegacyStyleCompatShell.vue?vue&type=script&lang=js"
export * from "./LegacyStyleCompatShell.vue?vue&type=script&lang=js"

import "./LegacyStyleCompatShell.vue?vue&type=style&index=0&id=6258711e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6258711e"]])

export default __exports__